import {
  CLEAR_CREATE_TRANSACTION,
  SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE, SET_VIEW_TRANSACTION,
} from "../action";
import { paymentType } from "./initial-store";

const initialState = paymentType;

function transactionPaymentReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE:
      newState = {
        ...state,
        [action.payload.domainName]: action.payload.domainValue,
      };
      return newState;

    case CLEAR_CREATE_TRANSACTION:
      newState = initialState;
      return newState;


    case SET_VIEW_TRANSACTION:
      let paymentTypeData = {
            monthlyPayment: action.payload.leasePayment,
            cashDown: action.payload.retailCashDown,
            finRate: action.payload.retailFinRate,
            noOfMonths:
                action.payload.saleType === "LEASE_SALE"
                    ? action.payload.leaseMonths
                    : action.payload.saleType === "RETAIL_NOTE_SALE"
                        ? action.payload.retailFinMonth
                        : 0,
            paymentType:
                action.payload.saleType === "CASH_SALE"
                    ? "Cash Sale"
                    : action.payload.saleType === "LEASE_SALE"
                        ? "Lease"
                        : action.payload.saleType === "RETAIL_NOTE_SALE"
                            ? "Retail Note"
                            : null,
            pctAppldtoPurch: 0,
            purchOptAmt: action.payload.leasePurchase
        }
      newState = { ...paymentTypeData };
      return newState;

    default:
      return state;
  }
}

export default transactionPaymentReducer;
